
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import CustomAlert from "components/CustomAlert";
import MDInput from "components/MDInput";
import CircularProgress from '@mui/material/CircularProgress';


// Data
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useMaterialUIController, setLoading } from "context";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { ParameterAPI } from "api/ParameterAPI";


export default function EditParameters() {
  const [controller, dispatch] = useMaterialUIController();
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const navigate = useNavigate();
  const { loading } = controller;

  const { id } = useParams();

  const formSchema = yup.object().shape({
    valor: yup.number().required('El campo es requerido'),
    observaciones: yup.string(),
    sugerencia: yup.string(),
  })

  const { handleSubmit, control, formState: { errors, isSubmitting }, setValue, getValues } = useForm({ resolver: yupResolver(formSchema), });

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => {
    setAlert(false);
  }

  const onSubmit = (data) => {
    updateParameter(id, data);
  }

  const updateParameter = (id, data) => {
    return ParameterAPI.update(id, data)
      .then(response => {
        navigate('/parameters', { state: response.message });

      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
          window.scrollTo(0, 0);
        }
      });
  }

  const getParameter = (id, signal) => {
    return ParameterAPI.show(id, signal).then(response => {
      for (let [key, value] of Object.entries(response.parameter)) {
        setValue(key, value)
      }
    }).catch(error => {
      if (error.response) {
        navigate('/not-found');
      }
    }).finally(() => {
      setLoading(dispatch, false)
    });
  }


  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal

    setLoading(dispatch, true)
    getParameter(id, signal)

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container justifyContent="center" pb={3} >
        <MDBox sx={{
          width: '80%',
        }}>
          <MDBox mb={4} px={2} >
            <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
          </MDBox>
          <Card>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <MDBox p={2} lineHeight={0}>
                  <MDTypography variant="h5">Parámetros</MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Información del Parámetro: {getValues('parametro')}<MDTypography variant="h5">{getValues('parametro')}</MDTypography>
                  </MDTypography>
                </MDBox>
                <MDBox p={2} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <Grid container p={2} spacing={3}>
                    <Grid item xs={6} sm={6}>
                      <Controller
                        control={control}
                        name="valor"
                        render={({ field: { onChange, value } }) => (
                          <MDInput onChange={onChange} value={value || ''} label="Valor" variant="standard" fullWidth />
                        )}
                      />
                      {errors.valor && <MDTypography variant="button" color="error">{errors.valor?.message}</MDTypography>}
                    </Grid>


                    <Grid item xs={6} sm={6}>
                      <Controller
                        control={control}
                        name="observaciones"
                        render={({ field: { onChange, value } }) => (
                          <MDInput onChange={onChange} value={value || ''} label="Observaciones" variant="standard" fullWidth />
                        )}
                      />
                      {errors.observaciones && <MDTypography variant="button" color="error">{errors.observaciones?.message}</MDTypography>}
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Controller
                        control={control}
                        name="sugerencia"
                        render={({ field: { onChange, value } }) => (
                          <MDInput onChange={onChange} value={value || ''} label="Sugerencia" variant="standard" fullWidth />
                        )}
                      />
                      {errors.sugerencia && <MDTypography variant="button" color="error">{errors.sugerencia?.message}</MDTypography>}
                    </Grid>
                  </Grid>
                  <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }} p={5}>
                    <ButtonGroup>
                      <MDButton variant="gradient" color="secondary" onClick={() => navigate('/parameters')} >
                        Cancelar
                      </MDButton>
                      <MDButton variant="gradient" type="submit" color="info" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} color="info" /> : 'Guardar'}

                      </MDButton>
                    </ButtonGroup>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </Card>
        </MDBox>
      </Grid >
      <Footer />
    </DashboardLayout >
  );

}



